import { useState } from "react";
import { KnowledgeCard } from "@/components/KnowledgeCard";
import { ActivityFeed } from "@/components/ActivityFeed";
import { UniversalSearchHint } from "@/components/SidebarUniversalSearch";
import { CaptureKnowledgeDialog } from "@/components/CaptureKnowledgeDialog";
import { ExpandableGamificationCard } from "@/components/ExpandableGamificationCard";
import { Button } from "@/components/ui/button";

export default function Dashboard() {
  const [captureOpen, setCaptureOpen] = useState(false);

  const recentKnowledge = [
    {
      id: "1",
      title: "Understanding Neural Networks and Deep Learning",
      summary: "Comprehensive overview of neural network fundamentals, activation functions, and backpropagation algorithms.",
      source: "arxiv.org",
      tags: ["AI", "Machine Learning", "Neural Networks"],
      createdAt: new Date(Date.now() - 1000 * 60 * 60 * 3),
      type: "article" as const,
    },
    {
      id: "2",
      title: "Personal Productivity Systems Research",
      summary: "Analysis of different productivity methodologies including GTD, Zettelkasten, and PARA method for knowledge management.",
      tags: ["Productivity", "Knowledge Management", "Systems"],
      createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24),
      type: "note" as const,
    },
  ];

  const activities = [
    { id: "1", type: "capture" as const, title: "Captured: Understanding Neural Networks", timestamp: new Date(Date.now() - 1000 * 60 * 5) },
    { id: "2", type: "ai_insight" as const, title: "AI generated summary for ML basics", timestamp: new Date(Date.now() - 1000 * 60 * 30) },
    { id: "3", type: "note" as const, title: "Created note: Project Ideas", timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2) },
  ];

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold mb-2">Activity & Knowledge</h1>
        <p className="text-muted-foreground">View your recent knowledge captures and activity timeline.</p>
      </div>

      <ExpandableGamificationCard />

      <UniversalSearchHint />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold">Recent Knowledge</h2>
            <Button variant="outline" size="sm" onClick={() => setCaptureOpen(true)} data-testid="button-add-knowledge">
              Add Knowledge
            </Button>
          </div>
          {recentKnowledge.map((item) => (
            <KnowledgeCard key={item.id} {...item} />
          ))}
        </div>

        <div>
          <ActivityFeed activities={activities} />
        </div>
      </div>

      <CaptureKnowledgeDialog open={captureOpen} onOpenChange={setCaptureOpen} />
    </div>
  );
}
